import React from "react";
import NavigationBmr from "./NavigationBmr";
import { Page } from "advancement-solutions-components/dist/components";

const Component = ({ user }) => {
  return (
    <Page user={user}>
      <NavigationBmr />
    </Page>
  );
};

export default Component;
